import i18next from 'i18next';
import moment from 'moment';
import Utils from '../Utils';
import { EVENT } from "../events/listEvents";
import StorageHelper from '../StorageHelper';
import { BROWSER_KEY } from '../Foundation';
const namespacesDefault = 'default';
const backendURL =  '/estharmb/locales/';

/**
 * getI18nextConfig
 * 
 * Innit Object I18n
 * 
 */
export const getI18nextConfig = () => {

  resetLangsSessionStore();
  let currentLang;
  let langOnBrowser = sessionStorage.getItem('lng') || 'en';
  var re = new RegExp("^([a-z]{2}|[a-z]{2}-[a-z]{2})$");
  if(re.test(langOnBrowser)){
      //// console.log("langOnBrowser", langOnBrowser)
      currentLang = langOnBrowser;
  }
  if (currentLang == null) {
    currentLang = 'en';
  }

  i18next.on('languageChanged', function(currentLang) {
    moment.locale(currentLang);
  });

  i18next.init({
    lng: currentLang,
    fallbackLng: 'en',
    debug: false,
    ns: namespacesDefault,
    defaultNS: namespacesDefault,
    fallbackNS: namespacesDefault,
    keySeparator: '_._'
  }, function (err, t) {
    // init set content

  });    
 
  //Because some keys in orther languages are not translate, so we need to load English to default
  if(currentLang !== 'en'){
     // call fallbackLng languague
    callFallBackLanguage(backendURL, 'en');
  }
 

  callAPIlAddLangToI18n(i18next, backendURL, currentLang).then(
      () => {
          storeLangToLocal(currentLang);
      }
  )  
  return i18next
}

/**
 * loadLanguage
 * Call api get data json data and innit data for Language
 * 
 * @param {*} lng 
 */
export const loadLanguage = (lng, isFireEvent) => {
  if (lng != null) {
    lng = convertToCorrectedLang(lng);
    let preLang = sessionStorage.getItem('lng');
    if (preLang == null || preLang.toLowerCase() !== lng.toLowerCase()) {
      storeLangToLocal(lng);
      let langResultTranslate = JSON.parse(sessionStorage.getItem('lng-' + lng.toLowerCase()));
      if (langResultTranslate == null) {

        callAPIlAddLangToI18n(i18next, backendURL, lng).then(
          () => {
            storeLangToLocal(lng);
            i18next.changeLanguage(lng, (err, t) => {
              if (err) return console.log('something went wrong loading', err);
               //console.log('test: ' +  i18next.t('Now'))
              if (isFireEvent) fireEventLangChanged(preLang, lng);
            });
            
          }
        ).finally(() => {
          document.title = Utils.getPageTitle()
        })
      } else {
        if (!i18next.store.data[lng]) {
          i18next.store.data[lng] = langResultTranslate;
          i18next.addResourceBundle(lng, namespacesDefault, langResultTranslate[namespacesDefault], true, true);
        }
        i18next.changeLanguage(lng, (err, t) => {
              if (err) return console.log('something went wrong loading', err);
              //console.log('test: ' +  i18next.t('Now'))
              if (isFireEvent) fireEventLangChanged(preLang, lng);
            });
        document.title = Utils.getPageTitle()
      }
    }


  }
}

//Use for 1 file jsons
function callAPIlAddLangToI18n(i18next, pathUrl, lang) {
  if(lang == null || lang.length === 0){
     lang = 'en'
  }

  let url = pathUrl + lang.toLowerCase() + '/' + lang.toLowerCase() + '.json';
      // fix: call same request many times 
      return fetch(url)
        .then(res => res.json())
        .then(
          (result) => {
            i18next.store.data[lang] = result;
            i18next.addResourceBundle(lang, namespacesDefault, result[namespacesDefault], true, true);        
            sessionStorage.setItem('lng-' + lang.toLowerCase(), JSON.stringify(result));
          },

          (error) => {

          }
        );   
 
}

function resetLangsSessionStore() {
    let i = sessionStorage.length;
    while(i--) {
      let key = sessionStorage.key(i);
      var lngReg = new RegExp("^lng");
      if(lngReg.test(key)) {
        sessionStorage.removeItem(key);
      }  
    }
}

function callFallBackLanguage(pathUrl, lang) {
  if(lang == null || lang.length === 0){
     lang = 'en'
  }

  let url = pathUrl + lang.toLowerCase() + '/' + lang.toLowerCase() + '.json';
      // fix: call same request many times 
      return fetch(url)
        .then(res => res.json())
        .then(
          (result) => {
            sessionStorage.setItem('lng-' + lang.toLowerCase(), JSON.stringify(result));
          },

          (error) => {

          }
        );   
 
}

/**
 * convertToCorrectedLang
 * Ex:
 * convert from zh-cn to zh-CN
 * @param {*} lang 
 */
function convertToCorrectedLang(lang) {
   let langArray = lang.split("-");
  if(langArray.length >= 2){     
      return langArray[0]+'-'+langArray[1].toUpperCase();
  }
  else return lang 
}

function storeLangToLocal(lang){
    sessionStorage.setItem('lng', lang.toLowerCase());
    StorageHelper.saveBrowsersStorage(BROWSER_KEY.LANG, Utils.toLocaleCode(lang.toLowerCase()));
}
function fireEventLangChanged(preLang, newLang){
    if(preLang !== newLang) window.fireEvent(EVENT.LANGUAGE_CHANGE);
    //// console.log("fireEventLangChanged");
}

/**
 * getLangBaseOnURLPath
 * 
 * Detect current language base on current URL
 * 
 */
 export const getLangBaseOnURLPath = () => {
  const strUrl = window.location.pathname.replace(window.APP_ROUTER_BASE, "");
  const res = strUrl.split("/");
  const lang = res[1];
  return convertToCorrectedLang(lang);
}



// WEBPACK FOOTER //
// ./src/app/common/config/i18nConfiguration.js